<template>
    <glass-panel
        radius="md"
        class="analytics-section-error pa-5 d-flex align-center"
        style="gap:14px"
    >
        <div class="analytics-section-error__icon">
            <v-icon size="20" color="primary">mdi-alert-circle-outline</v-icon>
        </div>
        <div class="analytics-section-error__text">
            <div class="analytics-section-error__title">{{ label }}</div>
            <div class="analytics-section-error__hint">Tente recarregar a página em alguns instantes.</div>
        </div>
    </glass-panel>
</template>

<script>
export default {
    name: 'AnalyticsSectionError',
    props: {
        label: {
            type: String,
            default: 'Dados temporariamente indisponíveis.',
        },
    },
}
</script>

<style scoped>
.analytics-section-error__icon {
    width: 40px;
    height: 40px;
    border-radius: 9999px;
    background: rgba(112, 42, 225, 0.1);
    border: 1px solid rgba(112, 42, 225, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.analytics-section-error__title {
    font-family: var(--font-body);
    font-weight: 700;
    font-size: 0.9375rem;
    color: var(--color-on-surface);
}

.analytics-section-error__hint {
    font-family: var(--font-body);
    font-size: 0.8125rem;
    color: var(--color-on-surface-variant);
    margin-top: 2px;
}
</style>
